import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import withoutAuth from 'lib/auth/without-auth'
import RegisterV2 from 'services/Auth/screens/RegisterV2'

export default withoutAuth(
  RegisterV2,
  `${WEB_DESKTOP_RALALI_URL}`,
  null,
  'Signup Page',
)
